var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 9,
    viewBox: "0 0 10 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5h-9V4h9z"
  })));
}

export default __webpack_public_path__ + "40515e694327d1dbbcefd0b32c1714ab.svg";
export { SvgMinus as ReactComponent };